export default __webpack_public_path__ + "static/media/Armbands of the Shivering Stars.20fbc688.jpg";